export default {
  USE_SIGN_UP_MODAL: true,
};
